import React, { useState } from 'react';
import { View, Text, TouchableOpacity, FlatList, TextInput, Pressable } from 'react-native';
import { Colors } from '../../../globalStyles/ColorConfig';

import { Entypo } from '@expo/vector-icons';
import GlobalStyles from '../../../globalStyles/globalStyles';
import CustomComponent from '../../../components/CustomComponent';

const CompositeDropdown = ({ options, onSelect }:{ options: any, onSelect: any}) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');

  const handleSelect = (item: any) => {
    onSelect(item);
    setDropdownVisible(false);
    setSelectedOption(item);
  };

  return (
    <View style={{position: 'relative', zIndex: 2}}>
      <Pressable onPress={() => setDropdownVisible(!dropdownVisible)}>
        <View style={{flexDirection: 'row', alignItems: 'center'}}>
          <View 
          style={{
            flex: 1,
            padding: 14,
            borderWidth: 1,
            borderColor: dropdownVisible ? '#C0A46F' : 'transparent', 
            borderRadius: 10,
            backgroundColor: '#EEE'
          }}>
            <CustomComponent.TextView title={selectedOption ? selectedOption : "Select city"} textStyle={GlobalStyles.bodyText} />
          </View>  
          <Entypo name={dropdownVisible ? "chevron-small-up" : "chevron-small-down"} size={24} color="black" style={{ position: 'absolute', right: 10, opacity: 0.4 }} />
        </View>
      </Pressable>
      {dropdownVisible && (
        <View style={{position: 'absolute', top: 55, left: 0, right: 0, backgroundColor: Colors.gold10, padding: 8, borderWidth: 1, borderColor: '#ccc', borderRadius: 10,}}>
          <FlatList
            data={options}
            keyExtractor={(item, index) => index.toString()}
            renderItem={({ item }) => (
              <TouchableOpacity onPress={() => handleSelect(item)}>
                <Text style={[GlobalStyles.bodyText, { padding: 8, color: Colors.white000 }]}>{item}</Text>
              </TouchableOpacity>
            )}
          />
        </View>
      )}
    </View>
  );
};

export default CompositeDropdown;
